module.exports = __webpack_public_path__ + "img/7_201.df30fa33.png";